import { DISPATCH_API, WEB_ROUTES } from '~/utils/webConfig';
import { BIOMETRY_ROUTES, BIOMETRY_STATUS } from '~/components/profile/utils';

export default async function({ app, $api, softRedirect }) {
  const SUCCESS_CODE = 200;

  try {
    const {
      data: { status, error },
    } = await $api.dispatch(DISPATCH_API.GET_BIOMETRY_STATUS);

    if (error && error.details && error.details.code !== SUCCESS_CODE)
      return softRedirect(app.localePath(WEB_ROUTES.PROFILE_BIOMETRY));

    if (status)
      return softRedirect(app.localePath(BIOMETRY_ROUTES[status || BIOMETRY_STATUS.EXPIRED]));
  } catch (err) {
    app.$sentry.captureException(new Error(err));
  }
}
